import { render, staticRenderFns } from "./VisitModal.vue?vue&type=template&id=490f670c&scoped=true"
import script from "./VisitModal.vue?vue&type=script&lang=js"
export * from "./VisitModal.vue?vue&type=script&lang=js"
import style0 from "./VisitModal.vue?vue&type=style&index=0&id=490f670c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490f670c",
  null
  
)

export default component.exports